<template>
  <div class="full-page" v-show="visible">
    <title-bar
      :title="title||gettext('拜访记录')"
      showBack
      @back="hide"
      :useNative="useNative"
    ></title-bar>
    <div class="page-content">
      <slot></slot>
    </div>
    <div class="submit-wrap">
      <rich-button light @click="submitHandler">{{gettext('保存')}}</rich-button>
    </div>
  </div>
</template>

<script type="text/ecmascript-6">
import TitleBar from './TitleBar'

export default {
  name: 'page',
  props: {
    useNative: {
      default: false
    },
    title: {
      default: ''
    }
  },
  components: {
    TitleBar
  },
  data () {
    return {
      visible: false
    }
  },
  methods: {
    show () {
      this.visible = true
    },
    hide () {
      this.$emit('cancel')
      this.visible = false
    },
    submitHandler () {
      // 可设置拦截逻辑
      this.$emit('submit', () => {
        this.hide()
      })
    }
  }
}
</script>

<style lang="scss" scoped>
  .full-page {
    position: fixed;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    z-index: 9;
    background: #FFF;
    .page-content {
      position: absolute;
      top: 50Px;
      bottom: 50Px;
      box-sizing: border-box;
      width: 100%;
      overflow: scroll;
      padding: 20px;
      margin-top: var(--barheight);
    }
    .submit-wrap {
      position: absolute;
      bottom: 0;
      width: 100%;
    }
  }
@media only screen and (min-width: 800px) {
  .full-page {
    width: 600Px;
    margin: 0 auto;
  }
}
</style>
